import { useQuery } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall } from 'app/queries/types/TCall';

export const useAdminJobQuery = (call: TCall, jobId: string) =>
  useQuery({
    queryKey: adminJobsKeys.detail(jobId),
    refetchOnMount: 'always',
    queryFn: ({ signal }) => call(() => cancelOnSignal(AdminService.getJobById({ jobId }), signal)),
    enabled: Boolean(jobId),
  });
